import { ActiveConversationRow } from '../../../model/brokerConnections/ActiveConversationRow';

export interface GroupedConversationSection {
    statusName: string;
    priority: number;
    rows: ActiveConversationRow[];
}

export type ConversationGridItem =
    | {
          kind: 'group';
          groupKey: string;
          section: GroupedConversationSection;
      }
    | {
          kind: 'row';
          row: ActiveConversationRow;
          groupKey: string;
      };

type ConversationRowCandidate = {
    conversationId?: unknown;
    row?: unknown;
    item?: unknown;
};

export const getConversationRowFromEntry = (entry: unknown): ActiveConversationRow | null => {
    if (!entry || typeof entry !== 'object') {
        return null;
    }

    const candidate = entry as ConversationRowCandidate;

    if (typeof candidate.conversationId === 'string') {
        return entry as ActiveConversationRow;
    }

    if (candidate.row && typeof candidate.row === 'object') {
        const rowCandidate = candidate.row as { conversationId?: unknown };
        if (typeof rowCandidate.conversationId === 'string') {
            return candidate.row as ActiveConversationRow;
        }
    }

    if (candidate.item && typeof candidate.item === 'object') {
        const itemCandidate = candidate.item as { conversationId?: unknown };
        if (typeof itemCandidate.conversationId === 'string') {
            return candidate.item as ActiveConversationRow;
        }
    }

    return null;
};